import Cookie from "@templates/App/Cookies.js";
import Filter from "@modules/stock_locator/views/Filter/Filter.js";
import AOS from "aos";

const FilterRent = {
    type: '',
    period: '',

    init(el) {
        this.el = el.find('.group.radios.rent');
        this.prices = el.find('.prices .val');
        this.vehicleList = $('[block="list"].rent');

        if (!this.el.length || (!this.vehicleList.length && !$('[page="detail"]').length)) {
            return;
        }

        this.labels = this.el.find('label');
        this.inputs = this.el.find('input');

        this.start();
        this.bind();
    },
    start() {
        this.updatePaginator(true);

        this.setTypeAndPeriod();
        this.filterVehicles();
        this.setPrice();
    },
    bind() {
        this.inputs.unbind('click').click((evt) => {
            const input = $(evt.currentTarget);
            const name = input.attr('name');

            this.el.find('input[name="' + name + '"]').each((i, el) => {
                el.checked = false;
            })

            setTimeout(() => {
                input[0].checked = true;

                this.setTypeAndPeriod();
                this.filterVehicles();

                if (typeof VEHICLE_RENT_OPTIONS !== 'undefined') {
                    this.disablePeriodsDetail(input);
                }

                this.setPrice();

            }, 1)
        })
    },
    setTypeAndPeriod() {
        this.type = this.el.find('.buyback input:checked').val() || this.type;
        this.period = this.el.find('.period input:checked').val() || this.period;

        this.updateRadioInputs();
    },
    updateRadioInputs() {
        const cars = this.vehicleList.find('.car');

        if (!cars.length) {
            return;
        }

        this.el.find('.buyback input').each((i, el) => {
            const value = $(el).val();
            const find = `.${value}`;
            const foundResults = this.vehicleList.find('.car' + find);

            if (foundResults.length === 0) {
                $(el).closest('.checkbox').attr('disabled', 'disabled');
            } else {
                $(el).closest('.checkbox').removeAttr("disabled");
            }
        })

        const availableType = this.el.find('.buyback label:not([disabled])');

        if (availableType.length === 1) {
            this.el.find('.buyback input').prop('checked', false);

            const input = availableType.find("input");
            input.prop('checked', true);

            this.type = input.val();
        }

        this.el.find('.period input').each((i, el) => {
            const value = $(el).val();
            const find = `.${this.type}${value}`;
            const foundResults = this.vehicleList.find('.car' + find);

            if (foundResults.length === 0) {
                el.checked = false;
                $(el).closest('.checkbox').attr('disabled', 'disabled');
            } else {
                $(el).closest('.checkbox').removeAttr("disabled");
            }
        })

        const availablePeriods = this.el.find('.period label:not([disabled])');

        if (availablePeriods.length === 1) {
            this.el.find('.period input').prop('checked', false);

            const input = availablePeriods.find("input");
            input.prop('checked', true);

            this.period = input.val();
        }
    },
    setPrice() {
        const value = this.type + "-" + this.period;
        const expires = new Date();
        expires.setFullYear(expires.getFullYear() + 1);
        Cookie.set('buyback', value, expires);

        const currentPrice = this.prices.filter('.' + value);
        const oldPrice = this.prices.filter('.active');

        oldPrice.removeClass('active').addClass('hide')
        currentPrice.addClass('active').siblings();

        setTimeout(() => {
            oldPrice.removeClass('hide')
        }, 302)
    },
    filterVehicles() {
        const find = `${this.type}${this.period}`;
        const cars = this.vehicleList.find('.car');

        if (!cars.length) return;

        cars.each((_, car) => {
            $(car).toggleClass('hidden', !$(car).hasClass(find));
        });

        this.updatePaginator(false);
        AOS.refresh();
    },
    updatePaginator(init = true) {
        const paginatorEl = $('.pagination .count');
        const counter = paginatorEl.find('span');

        if (!paginatorEl.length) return;

        if (init) {
            counter.attr('value', counter.text());
        } else {
            const visibleCars = this.vehicleList.find('.car:not(.hidden)').length;
            counter.text(visibleCars);
        }
    },
    disablePeriods(input) {
        if (input.attr('name') !== "buyback") return;

        const disabled = this.el.find('.period [value="1"], .period [value="12"]');

        if (input.val() === 'bb') {
            disabled.each((i, el) => {
                el.checked = false;
                $(el).closest('.checkbox').attr('disabled', '')
            })

            this.el.find('.period [value="6"]')[0].checked = true;

            this.setTypeAndPeriod();
            this.filterVehicles();

            this.setPrice();
        } else {
            disabled.each((i, el) => {
                $(el).closest('.checkbox').removeAttr('disabled')
            })
        }
    },
    disablePeriodsDetail(input) {
        if (input.attr('name') !== 'buyback') return;

        const type = input.val();
        const periods = this.el.find('.period input');

        periods.each((_, el) => {
            const periodValue = $(el).val();

            el.checked = false;

            if (VEHICLE_RENT_OPTIONS[type][periodValue]) {
                $(el).closest('.checkbox').removeAttr('disabled')
            } else {
                $(el).closest('.checkbox').attr('disabled', '')
            }
        });

        if (Object.keys(VEHICLE_RENT_OPTIONS[type]).length === 1) {
            const firstAvailable = Object.keys(VEHICLE_RENT_OPTIONS[type])[0];
            this.el.find(`.period input[value="${firstAvailable}"]`).prop('checked', true);

            this.period = firstAvailable;
        }
    }
}

export default FilterRent;